import React from "react";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center w-full h-screen gap-10 px-4 py-8 bg-gray-50">
      {/* Title */}
      <h1 className="text-3xl font-bold text-gray-800">
        Welcome to the Main Dashboard
      </h1>

      {/* Button Row */}
      <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-6">
        {/* Order Dashboard */}
        <button
          onClick={() => navigate("/order-dashboard")}
          className="text-lg font-semibold px-8 py-4 rounded shadow-md
                     bg-[#FFDEC5] text-gray-800
                     hover:bg-[#FECDA4] hover:shadow-lg
                     focus:outline-none focus:ring-4 focus:ring-[#FECDA4]"
        >
          Order Dashboard
        </button>

        {/* Booking Dashboard */}
        <button
          onClick={() => navigate("/booking-dashboard")}
          className="text-lg font-semibold px-8 py-4 rounded shadow-md
                     bg-[#FCD34D] text-gray-800
                     hover:bg-[#FBBF24] hover:shadow-lg
                     focus:outline-none focus:ring-4 focus:ring-[#FBBF24]"
        >
          Booking Dashboard
        </button>

        {/* Return Dashboard */}
        <button
          onClick={() => navigate("/return-dashboard")}
          className="text-lg font-semibold px-8 py-4 rounded shadow-md
                     bg-[#E9D5FF] text-gray-800
                     hover:bg-[#D8B4FE] hover:shadow-lg
                     focus:outline-none focus:ring-4 focus:ring-[#D8B4FE]"
        >
          Return Dashboard
        </button>

        {/* Inventory Dashboard */}
        <button
          onClick={() => navigate("/inventory-dashboard")}
          className="text-lg font-semibold px-8 py-4 rounded shadow-md
                     bg-[#C1E4EA] text-gray-800
                     hover:bg-[#B2D9DF] hover:shadow-lg
                     focus:outline-none focus:ring-4 focus:ring-[#B2D9DF]"
        >
          Inventory Dashboard
        </button>

        {/* Service Dashboard */}
        <button
          onClick={() => navigate("/service-dashboard")}
          className="text-lg font-semibold px-8 py-4 rounded shadow-md
                     bg-[#A7F3D0] text-gray-800
                     hover:bg-[#6EE7B7] hover:shadow-lg
                     focus:outline-none focus:ring-4 focus:ring-[#6EE7B7]"
        >
          Service Dashboard
        </button>

        {/* 📈 NEW — Subscription Dashboard */}
        <button
          onClick={() => navigate("/subscription-dashboard")}
          className="text-lg font-semibold px-8 py-4 rounded shadow-md
                     bg-[#BFDBFE] text-gray-800
                     hover:bg-[#93C5FD] hover:shadow-lg
                     focus:outline-none focus:ring-4 focus:ring-[#93C5FD]"
        >
          Subscription&nbsp;Dashboard
        </button>

        {/* 💧 NEW — Liquidation Dashboard */}
        <button
          onClick={() => navigate("/liquidation-dashboard")}
          className="text-lg font-semibold px-8 py-4 rounded shadow-md
                     bg-[#FECACA] text-gray-800
                     hover:bg-[#FCA5A5] hover:shadow-lg
                     focus:outline-none focus:ring-4 focus:ring-[#FCA5A5]"
          title="Track buyouts, returns, and liquidation revenue"
        >
          Liquidation&nbsp;Dashboard
        </button>
      </div>
    </div>
  );
}
